import {
	AnyRoute,
	createRootRoute,
	createRoute,
	createRouter,
	RouterOptions
} from '@tanstack/react-router';

import config from '@/config';
import { basepath } from '@/constants';
import { TemplatePoets } from '@/config.type';

import { HomeView } from '@/views/home/Home';
import { useAuth } from '@/views/home/auth/Authentication.hooks';
import { IssueView } from '@/views/issue/Issue';
import Drafts from '@/views/drafts/Drafts';
import { FeedState, FeedView } from '@/views/feed/Feed';
import Preview from '@/views/preview/Preview';
import Favorite from '@/views/favorite/Favorite';
import { NotFound, RootRouteComponent } from '@/views/RootRoute';
import { homeSearchSchema } from '@/views/home/Home.hooks';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';

type GlobalRouterState = FeedState | {};

/* Routes declaration */

const rootRoute = createRootRoute({
	component: RootRouteComponent,
});

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	validateSearch: homeSearchSchema,
	component: Home,
});

const issuesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: 'issues',
	component: IssueView,
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: AuthIssue,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	validateSearch: issueSearchSchema,
	component: AuthIssue,
	path: '$articleId',
});

const previewRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Preview,
	path: 'preview/$id',
});

const favoriteRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Favorite,
	path: 'favorite/$id',
});

const draftsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Drafts,
	path: 'drafts',
});

const feedRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: FeedView,
	path: 'feed',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	issuesRoute,
	issueRoute,
	issueArticleRoute,
];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

const template = config.app.template as TemplatePoets;

if (config.app.favorite) {
	routes.push(favoriteRoute);
}

if (config.app.template?.type === 'poets') {
	const { skipTOC, feed } = template.config;
	if (!skipTOC) {
		routes.push(previewRoute);
	}
	if (feed) {
		routes.push(feedRoute);
	}
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,

} satisfies RouterOptions<
  typeof routeTree,
  any,
  any,
  any,
  GlobalRouterState
>);

function Home() {
	useAuth({ redirect: false });
	return (
		<>
			<HomeView />
		</>
	);
}

function AuthIssue() {
	useAuth({ redirect: true });
	return (
		<>
			<IssueView />
		</>
	);
}
